import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    checkVotes();

    htmx.on("htmx:afterSwap", function(evt) {
        checkVotes();
    });
}

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

function checkVotes() {
    let votes = getCookie('xaverv');

    if (votes) {
        votes = JSON.parse(decodeURIComponent(votes));
    }
    else {
        votes = [];
    }

    let voteElements = document.querySelectorAll('a.vote:not(.processed)');
    if (voteElements) {
        let nonce = document.body.dataset.nossRestNonce;
        for (let i = 0; i < voteElements.length; ++i) {
            voteElements[i].classList.add('processed');
            if (!votes.includes(parseInt(voteElements[i].dataset.nossPid))) {
                voteElements[i].setAttribute('data-noss-voteable', '1');
            }
            voteElements[i].addEventListener('click', function (event) {
                event.preventDefault();
                if (!event.target.hasAttribute('data-noss-clicked')) {
                    let cookieEmail = getCookie('xaverve');
                    let emailInput = HTMLInputElement;
                    let email = undefined;

                    let textData = event.target.closest('[data-confirm-title]');

                    Swal.fire({
                        title: textData.dataset.confirmTitle,
                        html: '<input type="text" id="voting-email" class="form-control" value="' + (cookieEmail !== undefined ? cookieEmail : '') + '" placeholder="' + textData.dataset.confirmPlaceholder + '">',
                        confirmButtonText: textData.dataset.confirmButton,
                        buttonsStyling: false,
                        focusConfirm: false,
                        customClass: {
                            confirmButton: 'btn btn-black'
                        },
                        didOpen: () => {
                            const popup = Swal.getPopup();
                            emailInput = document.querySelector('input[id="voting-email"]');
                            emailInput.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm();
                        },
                        preConfirm: () => {
                            email = emailInput.value;
                            if (!email) {
                                Swal.showValidationMessage(textData.dataset.confirmEmpty);
                            }
                            else {
                                if (!validateEmail(email)) {
                                    Swal.showValidationMessage(textData.dataset.confirmInvalid);
                                }
                                else {
                                    if (email.includes('+')) {
                                        Swal.showValidationMessage(textData.dataset.confirmPlus);
                                    }
                                }
                            }
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            event.target.setAttribute('data-noss-clicked', '1');
                            voteElements[i].removeAttribute('data-noss-voteable');

                            if (cookieEmail === undefined || cookieEmail !== email) {
                                document.cookie = 'xaverve=' + email;
                            }

                            let formData = new FormData();
                            formData.append('_wpnonce', nonce);
                            formData.append('email', email);

                            fetch(event.target.href, {
                                method: 'POST',
                                body: formData
                            });

                            Swal.fire({
                                title: textData.dataset.msgTitle,
                                text: textData.dataset.msgMessage,
                                icon: "success",
                                confirmButtonText: textData.dataset.msgButton,
                                buttonsStyling: false,
                                customClass: {
                                    confirmButton: 'btn btn-black'
                                },
                            });
                        }
                    });
                }
            });
        }
    }
}
function getCookie (name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}